"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var path_helper_1 = require("./config/path.helper");
var dummy_me_entity_search_service_1 = require("./dummy-me-entity-search.service");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
 * @author Gevorg Avetisyan on 12/2/2018.
 */
var HttpMeEntitySearchService = /** @class */ (function () {
    function HttpMeEntitySearchService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.entityServiceUriKey = "entity-search-service-url";
        this.entityServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(this.entityServiceUriKey));
    }
    HttpMeEntitySearchService.prototype.getIndicators = function (systemName, filter, paging, languageId, sortField, sortOrder) {
        var _this = this;
        var kbPrefix = 'me';
        var categoryPermissionTypes = 'VIEW';
        var params = {
            kbPrefix: kbPrefix,
            filter: encodeURIComponent(JSON.stringify(filter || {})),
            paging: JSON.stringify(paging),
            categoryPermissionTypes: categoryPermissionTypes
        };
        if (sortField && sortOrder) {
            params['sortField'] = sortField;
            params['sortOrder'] = sortOrder;
        }
        return this.entityServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.ENTITY + systemName, { params: params }); }), operators_1.map(function (res) { return dummy_me_entity_search_service_1.Convert.convertJsonToEntitySearchModel(res); }));
    };
    HttpMeEntitySearchService.prototype.getIndicatorFromEntitySearch = function (filter, paging, languageId, sortField, sortOrder) {
        var _this = this;
        var kbPrefix = 'me';
        var categoryPermissionTypes = 'VIEW';
        var params = {
            kbPrefix: kbPrefix,
            filter: encodeURIComponent(JSON.stringify(filter || {})),
            paging: JSON.stringify(paging),
            categoryPermissionTypes: categoryPermissionTypes
        };
        if (sortField && sortOrder) {
            params['sortField'] = sortField;
            params['sortOrder'] = sortOrder;
        }
        return this.entityServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.ENTITY_INDICATOR, { params: params }); }), operators_1.map(function (res) { return dummy_me_entity_search_service_1.Convert.convertToEntitySearchToIndicatorView(res); }));
    };
    HttpMeEntitySearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpMeEntitySearchService);
    return HttpMeEntitySearchService;
}());
exports.HttpMeEntitySearchService = HttpMeEntitySearchService;
//# sourceMappingURL=http-me-entity-search.service.js.map